import getRecordSelector from 'root/src/client/logic/api/selectors/getRecordSelector'
import prop from 'ramda/src/prop'
import compose from 'ramda/src/compose'

export default compose(prop('status'), getRecordSelector)
